import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { useDpvaleFlow } from '@/data/Content/Dpvale';
import { DpvaleSelectedCard } from '@/components/blocks/DpvaleSelectedCard';
import { DpvaleOptionCard } from '@/components/blocks/DpvaleOptionCard';
import { DpvaleEmptyCard } from '@/components/blocks/DpvaleEmptyCard';

export const AccountDpVale = () => {
	const {
		dpValesDisponibles,
		isLoading: loadingDpValesDisponibles,
		currentSelectedDpvale,
		setDpvaleSelected,
	} = useDpvaleFlow();

	return (
		<Box>
			{currentSelectedDpvale ? (
				<>
					<Typography
						sx={{
							fontSize: 'var(--font-size-md)',
							fontWeight: 800,
						}}
					>
						{'dpvale activo'}
					</Typography>
					<Typography
						sx={{
							marginBottom: '16px',
						}}
					>
						{'Para cambiar de dpvale activo, haz clic en el vale disponible al que deseas cambiar'}
					</Typography>

					<Grid container sx={{ transition: 'all 0.3s ease' }}>
						<Grid item xs={12} md={6}>
							<DpvaleSelectedCard
								distributorName={currentSelectedDpvale?.distributor.name || ''}
								recurrent={currentSelectedDpvale?.recurrente || false}
								amount={currentSelectedDpvale?.amount || 0}
							/>
						</Grid>
					</Grid>
				</>
			) : null}

			<Typography
				sx={{
					fontSize: 'var(--font-size-md)',
					fontWeight: 800,
					marginY: '16px',
				}}
			>
				{'Tus dpvale disponibles'}
			</Typography>

			<Grid container spacing={2}>
				{loadingDpValesDisponibles ? (
					<>
						{Array.from({ length: 4 }).map((_, index) => (
							<Grid item xs={12} sm={6} md={4} lg={3} key={index}>
								<Skeleton variant="rectangular" width="100%" height="80px" />
							</Grid>
						))}
					</>
				) : dpValesDisponibles.length === 0 ? (
					<Grid item xs={12}>
						<DpvaleEmptyCard />
					</Grid>
				) : (
					<>
						{dpValesDisponibles.map((dpVale) => (
							<Grid item xs={12} sm={6} md={4} lg={3} key={dpVale.id}>
								<DpvaleOptionCard
									selected={currentSelectedDpvale?.id === dpVale.id}
									distributorName={dpVale.distributor.name}
									recurrent={dpVale.recurrente}
									folio={dpVale.folio}
									amount={dpVale.amount}
									onClick={() =>
										setDpvaleSelected({
											id: dpVale.id,
											folio: dpVale.folio,
											distributorId: dpVale.distributor.id,
										})
									}
								/>
							</Grid>
						))}
					</>
				)}
			</Grid>
		</Box>
	);
};
